import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  horizontalRule: {
    position: 'absolute',
    margin: 0,
    width: '100%',
    color: theme.palette.facet.lightGray,
  },
  left: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  center: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
  },
  right: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
  },
});

const SequenceBar = React.forwardRef((props, ref) => {
  const {
    className, classes, left, center, right,
  } = props;
  return (
    <div className={classNames(classes.root, className)} ref={ref}>
      <hr className={classes.horizontalRule} />
      <div className={classes.left}>{left}</div>
      <div className={classes.center}>{center}</div>
      <div className={classes.right}>{right}</div>
    </div>
  );
});

SequenceBar.defaultProps = {
  className: '',
  left: [],
  right: [],
};

SequenceBar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  left: PropTypes.arrayOf(PropTypes.node),
  center: PropTypes.arrayOf(PropTypes.node).isRequired,
  right: PropTypes.arrayOf(PropTypes.node),
};

export default withStyles(styles, { name: 'SequenceBar' })(SequenceBar);
